import { Link } from "react-router-dom";
import { useCategories } from "../../hooks/useCategories";
import { useCategoriesCache } from "../../hooks/useCategoriesCache";

export function SecondaryNav() {
  const { data: categories, isLoading, error } = useCategories();

  // Armazena as categorias no cache
  useCategoriesCache(categories);

  // Estilos base fixos para a barra
  const fixedNav =
    "fixed top-20 w-full z-40 bg-gray-900 py-2 shadow-md";

  if (isLoading) {
    return (
      <nav className={fixedNav}>
        <div className="container mx-auto px-4">
          <div className="flex items-center justify-center">
            <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-gray-100"></div>
            <span className="ml-2 text-sm text-gray-200">
              Carregando categorias...
            </span>
          </div>
        </div>
      </nav>
    );
  }

  if (error) {
    return (
      <nav className={fixedNav}>
        <div className="container mx-auto px-4">
          <div className="flex items-center justify-center">
            <span className="text-sm text-red-300">
              Erro ao carregar categorias
            </span>
          </div>
        </div>
      </nav>
    );
  }

  return (
    <nav className={fixedNav}>
      <div className="container mx-auto px-4">
        <div className="flex justify-center items-center space-x-6 overflow-x-auto">
          {categories?.map((category) => {
            const urlFormatada = category.url
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, "")
              .replace(/\//g, "")
              .toLowerCase();

            return (
              <Link
                key={category.id}
                to={{
                  pathname: `/categoria/${urlFormatada}`,
                  state: { id: category.id },
                }}
                className="text-white hover:text-green-500 whitespace-nowrap transition-colors duration-200"
              >
                {category.name}
              </Link>
            );
          })}
        </div>
      </div>
    </nav>
  );
}
